export default "__VITE_PUBLIC_ASSET__237424fe__"